module.exports = __webpack_public_path__ + "static/media/fragaria-min.5ef31030.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/fragaria-min.png
// module id = 244
// module chunks = 0